import React, { useState } from 'react'
import { FaMinus, FaPlus } from 'react-icons/fa'
import { authService } from '../../../services/authService';
import { useDispatch } from 'react-redux';
import { cartItemUpdate, productPurchaseGet } from '../../../store/actions';
import { updateCart } from '../../../core/utils/CartHelpers';
import toast from 'react-hot-toast';

const MonthSelectionComponent = ({ item, fetchedPlans, setTotalPlansQty, calculateTotalPlansQty }) => {
  const dispatch = useDispatch();
  const [count, setCount] = useState(+item?.JSON_String?.plan?.number_of_months);
  const userEmail = authService.getCurrentUserEmail();

  const handleCartUpdate = (item, newCount) => {
    try {
      const selectedPlanDetails = fetchedPlans?.filter(
        (fPlan) => fPlan?.name === item.JSON_String?.plan?.plan_name
      );

      const data = {
        plan_name: item.JSON_String?.plan?.plan_name,
        plan_quantity: item.JSON_String?.plan?.plan_quantity.toString(),
        plan_price: selectedPlanDetails[0]?.recurring_price,
        plan_code: selectedPlanDetails[0]?.plan_code,
        isRecurring: item.JSON_String?.plan?.isRecurring,
        product_id: selectedPlanDetails[0]?.product_id,
        interval: "1",
        interval_unit: "months",
        number_of_months: newCount.toString(),
      };

      const payload = {
        data,
        user_email: userEmail,
        itemId: item.itemId,
      };

      dispatch(cartItemUpdate(payload))
        .unwrap()
        .then(() => {
          updateCart(
            dispatch,
            productPurchaseGet,
            calculateTotalPlansQty,
            setTotalPlansQty
          );
          toast.success("Cart item updated!");

          // handleContinue();
        })
        .catch((err) => {
          toast.error("Something Went Wrong!");

          return err;
        });
    } catch (e) {
      return e;
    }
  };


  return (
    <div className='w-fit px-2 py-1.5 bg-[#E4E4E4] rounded-lg flex flex-row items-center space-x-2 ring-1 ring-gray-300'>
      <button
        onClick={() => {
          const newCount = Math.max(0, count - 1);
          setCount(newCount);
          handleCartUpdate(item, newCount);
        }}
        className='h-4 w-4 rounded-full flex items-center justify-center bg-gray-200 active:bg-gray-100'
      >
        <FaMinus className='h-2.5 w-2.5 text-gray-600' />
      </button>

      <div className='text-gray-600 text-sm'>{count} {count < 2 ? "Month" : "Months"}</div>

      <button
        onClick={() => {
          const newCount = count + 1;
          setCount(newCount);
          handleCartUpdate(item, newCount);
        }}
        className='h-4 w-4 rounded-full flex items-center justify-center bg-gray-200 active:bg-gray-100'
      >
        <FaPlus className='h-2.5 w-2.5 text-gray-600' />
      </button>

    </div>
  )
}

export default MonthSelectionComponent